<template>
  <div v-if="showPromoModal">
    <SimonModal
      :is-visible="showOverlay && getActiveModal === 'promo'"
      :show-footer-buttons=twoButtons
      custom-modal-class="promo-modal"
      @hide="showOverlay = false"
      :btn-cancel-title="getSlotText('lblClose')"
      :btn-right-title="getSlotText('lblRight')"
      :btn-left-title="getSlotText('lblLeft')"
      @btnCancelEvent="showOverlay = false"
      @btnRight="goToUrl()"
      @btnLeft="showOverlay = false"
    >
      <template v-slot:modalTitle>
        <h3>
          <slot name="lblHeadline"></slot>
        </h3>
      </template>
      <div class="promo-modal--body">
        <div class="info">
          <slot name="txtInfo"></slot>
        </div>
        <div class="img">
          <slot name="imgVisual"></slot>
        </div>
      </div>
    </SimonModal>
  </div>
</template>

<script>
import useFeature from '@/mixins/useFeature'
import SimonModal from '@/components/modal/SimonModal.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PromoModal',
  components: { SimonModal },
  mixins: [
    useFeature('showPromoModal')
  ],
  data () {
    return {
      showOverlay: false
    }
  },
  mounted () {
    if (this.showPromoModal) {
      const promoKey = this.getSlotText('lblPromoKey') !== '' ? this.getSlotText('lblPromoKey') : 'promoModal'
      const probingCookie = window.cookieNS.main.getCookie('probing')
      if (probingCookie) {
        return
      }
      let simonAppCookie = window.cookieNS.main.getCookie('simonApp')
      if (!simonAppCookie) {
        window.cookieNS.main.setSimonAppCookie(promoKey, 1)
        this.showOverlay = true
        this.setActiveModal('promo')
      } else {
        simonAppCookie = JSON.parse(simonAppCookie)
        if (!simonAppCookie[promoKey]) {
          window.cookieNS.main.setSimonAppCookie(promoKey, 1)
          this.showOverlay = true
          this.setActiveModal('promo')
        }
      }
    }
  },
  watch: {
    showOverlay: function (newVal) {
      if (newVal && this.showPromoModal) {
        this.setActiveModal('promo')
      } else {
        this.setActiveModal('')
      }
    }
  },
  computed: {
    ...mapGetters('modals', [
      'getActiveModal'
    ]),
    twoButtons () {
      return this.getSlotText('rightButton') === '1'
    }
  },
  methods: {
    ...mapMutations('modals', [
      'setActiveModal'
    ]),
    goToUrl () {
      window.location.href = this.getSlotText('urlModal')
    }
  }
}
</script>
